import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import './styles/global.scss';
import { BrowserRouter } from 'react-router-dom';
import { TadsWidgetProvider } from 'react-tads-widget';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <TadsWidgetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </TadsWidgetProvider>
  </React.StrictMode>,
);
